import React, { ReactNode } from "react";
import { Container, Grid } from "@material-ui/core";
import styled from "styled-components";
import Theme from "../Theme";
import { IApplicationState } from "../store";
import { selectAuth } from "../store/auth/selectors";
import { connect } from "react-redux";
import StartupBar from "./StartupBar";
import SignupBar from "./signup/SignupBar";
import { RouteComponentProps, withRouter } from "react-router";

const Wrapper = styled.div`
  padding: 2em 0;
`;

const ContentBar = styled(Grid)`
  padding: 2em;
`;

const SideBar = styled(Grid)`
  padding: 2em;
  border-left: 1px solid ${Theme.colors.blackText};
`;

export interface IWithHelperBarProps extends RouteComponentProps {
  children: ReactNode;
  isAuthenticated: boolean;
}

const WithHelperBar = (props: IWithHelperBarProps) => {
  const {
    children,
    isAuthenticated,
    location: { pathname },
  } = props;
  const loc = (pathname || "").toLowerCase();

  const showSignUp = !isAuthenticated && !loc.startsWith("/apply") && !loc.startsWith("/authentication/logged-out");

  return (
    <Wrapper>
      <Grid container>
        <ContentBar item xs={12} md={8}>
          {children}
        </ContentBar>
        <SideBar item xs={12} md={4}>
          {showSignUp ? <SignupBar /> : <StartupBar />}
        </SideBar>
      </Grid>
    </Wrapper>
  );
};

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(withRouter(WithHelperBar));
